module.exports = __webpack_public_path__ + "static/media/gear.9f095719.svg";